/**
 * useLadderRung — how a ladder position is written for a person to read.
 *
 * One rule, because the ladder page and the place-players dialog were saying the same
 * thing two different ways. The page already wrote "2nd on the ladder"; the dialog
 * appended a bare "(2)" to the end of the team name, which is ambiguous on a doubles
 * ladder (it reads as a member count) and, worse, is the FIRST thing a select ellipsises
 * away — so on a long pairing the rank simply disappeared.
 *
 * Mirrored by the app's `ordinal()` in lib/app/utils.dart and the rung subtitle in
 * place_players_sheet.dart. Change both together.
 *
 * Imported explicitly (house style), not relied on via auto-import.
 */
export function useLadderRung() {
    /** 1 -> "1st", 2 -> "2nd", 11 -> "11th", 112 -> "112th". */
    const rungOrdinal = (n) => {
        if (n % 100 >= 11 && n % 100 <= 13) return `${n}th`;
        return `${n}${({1: 'st', 2: 'nd', 3: 'rd'})[n % 10] ?? 'th'}`;
    };

    /**
     * The rung as a standalone line, or null when the team has no position yet.
     * Null rather than an empty string so a caller can drop the element entirely.
     */
    const rungLabel = (position) => (position ? `${rungOrdinal(position)} on the ladder` : null);

    return {rungOrdinal, rungLabel};
}
